export const LANGUAGES = [
    { label: "Čeština", code: "cs" },
    { label: "English", code: "en" },
];

// Minutes after session end when parking limit resets (allows new maxHour limit)
export const SESSION_RESET_MINUTES = 15;

export const PARKING_TIME_VALUES = [
    { value: "60", label: "", labelString: "timeOptions.60minutes", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "90", label: "", labelString: "timeOptions.90minutes", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "120", label: "", labelString: "timeOptions.2hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "180", label: "", labelString: "timeOptions.3hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "240", label: "", labelString: "timeOptions.4hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "300", label: "", labelString: "timeOptions.5hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "360", label: "", labelString: "timeOptions.6hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "420", label: "", labelString: "timeOptions.7hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "480", label: "", labelString: "timeOptions.8hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "540", label: "", labelString: "timeOptions.9hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "600", label: "", labelString: "timeOptions.10hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "660", label: "", labelString: "timeOptions.11hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "720", label: "", labelString: "timeOptions.12hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "780", label: "", labelString: "timeOptions.13hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "840", label: "", labelString: "timeOptions.14hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "900", label: "", labelString: "timeOptions.15hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "960", label: "", labelString: "timeOptions.16hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1020", label: "", labelString: "timeOptions.17hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1080", label: "", labelString: "timeOptions.18hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1140", label: "", labelString: "timeOptions.19hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1200", label: "", labelString: "timeOptions.20hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1260", label: "", labelString: "timeOptions.21hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1320", label: "", labelString: "timeOptions.22hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1380", label: "", labelString: "timeOptions.23hours", isDisabled: false, optionHeaderText: null, isDanger: false },
    { value: "1440", label: "", labelString: "timeOptions.24hours", isDisabled: false, optionHeaderText: null, isDanger: false },
];

export const PAID_NOTIFICATION_TIMES = [
    { value: "0", label: "", labelString: "paid.notification.optionWithout" },
    { value: "5", label: "", labelString: "paid.notification.option5minutes" },
    { value: "15", label: "", labelString: "paid.notification.option15minutes" },
    { value: "30", label: "", labelString: "paid.notification.option30minutes" },
];

interface PARK_MACHINE_TYPE {
    infobox: string;
    parkingMachine: string;
}

export const PARK_MACHINE_TYPE: Readonly<PARK_MACHINE_TYPE> = {
    infobox: "FAKE",
    parkingMachine: "STANDARD",
};

type TParkingQueryKeys = {
    base: readonly ["parking"];
    price: {
        base: () => readonly ["parking", "price"];
        get: (section: string, licensePlate:string, minutes: number, parkMachineCode: string) => readonly ["parking", "price", string, string, number, string];
    };
    priceByMinutes: {
        base: () => readonly ["parking", "priceByMinutes"];
        get: (licensePlate: string, featureType: string, featureCode: string, requestTime: string) => readonly ["parking", "priceByMinutes", string, string, string, string];
    };
    section: {
        base: () => readonly ["parking", "section"];
        get: (sectionCode: string) => readonly ["parking", "section", string];
    };
    parkMachine: {
        base: () => readonly ["parking", "parkMachine"];
        get: (parkMachineCode: string) => readonly ["parking", "parkMachine", string];
    };
};

export const parkingQueryKeys: TParkingQueryKeys = {
    base: ["parking"] as const,

    price: {
        base: () => [...parkingQueryKeys.base, "price"] as const,
        get: (section: string, licensePlate:string, minutes: number, parkMachineCode: string) =>
            [...parkingQueryKeys.price.base(), section, licensePlate, minutes, parkMachineCode] as const,
    },
    priceByMinutes: {
        base: () => [...parkingQueryKeys.base, "priceByMinutes"] as const,
        get: (licensePlate:string, featureType: string, featureCode: string, requestTime: string) =>
            [...parkingQueryKeys.priceByMinutes.base(), licensePlate, featureType, featureCode, requestTime] as const,
    },
    section: {
        base: () => [...parkingQueryKeys.base, "section"] as const,
        get: (sectionCode: string) => [...parkingQueryKeys.section.base(), sectionCode] as const,
    },
    parkMachine: {
        base: () => [...parkingQueryKeys.base, "parkMachine"] as const,
        get: (parkMachineCode: string) => [...parkingQueryKeys.parkMachine.base(), parkMachineCode] as const,
    },
};

export const apiTimeExceededErrorMessages = [
    "Api Error: Tariff's MaxHour exceeded by existing parking sessions",
    "Api Error: TariffLLF API returned no segments",
    "No valid parking duration found",
];
